const environmentData = require(`./environments/${
  process.env.REACT_APP_SECURECOM_ENV || "production"
}`);

export default environmentData;
